/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import ResponsiveValue, { Container } from './styled/Value.styled';
import { genDataValue } from '../../utils/formatCharts/handleData';
import { labelValuesStr } from '../../utils/formatCharts/handleCustomValue';

const emptyObj = {};

const Value = ({
  data, styleConfig, valueFunction, globalConfig = emptyObj,
}) => {
  const [chartData, setChartData] = useState({ ready: false });

  useEffect(() => {
    setChartData(genDataValue(data, styleConfig, valueFunction === 'mean'));
  }, [
    data,
    valueFunction,
    styleConfig?.TotalFunctionControl,
    styleConfig?.MinValueControl?.checked,
    styleConfig?.MinValueControl?.value,
    styleConfig?.MaxValueControl?.checked,
    styleConfig?.MaxValueControl?.value,
  ]);

  return chartData.ready ? (
    <Container
      background={
        globalConfig?.useGlobalTheme ? globalConfig.valueBg : styleConfig?.GlobalValue?.background
      }
    >
      <ResponsiveValue
        fontSize={styleConfig?.GlobalValue?.fontSize || 20}
        color={globalConfig?.useGlobalTheme ? globalConfig.valueTxt : styleConfig?.GlobalValue?.color ?? '#222222'}
        fontFamily={(globalConfig?.useGlobalFont ? globalConfig.fontValue : styleConfig?.GlobalValue?.fontFamily) || 'Arial'}
        bold={styleConfig?.GlobalValue?.bold}
        underline={styleConfig?.GlobalValue?.underline}
        italic={styleConfig?.GlobalValue?.italic}
      >
        {labelValuesStr(chartData.value, null, styleConfig)}
        <span className="desc">{styleConfig?.DescriptionControl}</span>
      </ResponsiveValue>
    </Container>
  ) : <></>;
};

Value.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  styleConfig: PropTypes.objectOf(PropTypes.any),
  valueFunction: PropTypes.string.isRequired,
  globalConfig: PropTypes.objectOf(PropTypes.any),
};

export default Value;
